export const Currency = {
  REAL: { id: 1, symbol: "R$" },
  DOLAR: { id: 2, symbol: "U$" },
  EURO: { id: 3, symbol: "EUR" },
};



// WEBPACK FOOTER //
// ./src/enums/Currency.js